import { createApp } from 'vue';
import Results from '../../../../investors/Results';
import store from '../../../../store/modules/investors';

createApp(Results).use(store).mount('#app');
